import DomesticGasSafetyForm from './DomesticGasSafetyForm';
import DomesticGasSafetyPDF from './DomesticGasSafetyPDF';
import schema from './schema';
import validator from './validator';
import defaultData from './defaultData';
import { transformForPDF } from './transform';


export default {
  Form: DomesticGasSafetyForm,
  PDF: DomesticGasSafetyPDF,
  schema,
  validator,
  defaultData,
  transform: transformForPDF,
  
};
